const getWidgetInstanceKey = (field) =>
  String(field?.field_instance_id ?? field?.name ?? "");

export const updatePreviewFieldInstanceLabel = (
  fields = [],
  targetField,
  nextLabel,
) => {
  const targetKey = getWidgetInstanceKey(targetField);
  const normalizedLabel = String(nextLabel ?? "").trim();

  if (!targetKey || !normalizedLabel) return fields;

  let changed = false;
  const updatedFields = fields.map((field) => {
    if (getWidgetInstanceKey(field) !== targetKey) return field;

    if (
      field?.field_label === normalizedLabel &&
      field?.label === normalizedLabel
    ) {
      return field;
    }

    changed = true;
    return {
      ...field,
      field_label: normalizedLabel,
      label: normalizedLabel,
    };
  });

  return changed ? updatedFields : fields;
};
